import * as React from "react";
import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import classes from './Header.module.scss';
import Logo from '../../assets/Logo.png';
import { GetUserAuthorization } from "../../utils/customHooks";
import { CartHeader, ProfileHeader, WishlistHeader } from "../../assets/customIcons/HeaderIcons";
import { CartContext } from "../../context/CartContext";
import { useContext } from "react";
import { LAUNCH_MODE } from "../../siteConfig";

const NAV_LINKS = [
    { label: 'About Us', to: '/about-us' },
    { label: 'Mission', to: '/mission' },
    { label: 'Vision', to: '/vision' },
    { label: 'Contact', to: '/contact-us' },
];

export const Header = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = useContext(CartContext);
    const locationPathName = location.pathname;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const SelectedSVGStyle = {
        outerFill: "#CBA894",
        pathColor: "#FFFFFF",
    }

    // Close the mobile menu whenever navigation happens.
    useEffect(() => {
        setIsMenuOpen(false);
    }, [locationPathName]);

    const navItems = NAV_LINKS.map((link) => (
        <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) => `${classes.NavLink} ${isActive ? classes.NavLinkActive : ''}`}
        >
            {link.label}
        </NavLink>
    ));

    return (
        <>
            <div className={classes.div2}>
                <div className={classes.div3}>
                    <img
                        src={Logo}
                        alt="Abayatique"
                        className={classes.img}
                        onClick={() => navigate('/')}
                    />
                </div>

                <div className={classes.div7}>
                    <nav className={classes.NavLinks} aria-label="Primary">
                        {navItems}
                    </nav>

                    {/* Launch mode: cart/wishlist/profile and Login/Sign Up all point at
                        routes that no longer exist, so only the info links above show. */}
                    {LAUNCH_MODE ? null : GetUserAuthorization() ?
                        <div className={classes.HeaderNavIcons}>
                            <div className={classes.CartContainer} onClick={() => navigate("/cart")}>
                                <CartHeader {...(locationPathName === "/cart" ? SelectedSVGStyle : {})} />
                                {state.cartItems.length ? <div className={classes.cartItemCount}>{state.cartItems.length}</div> : null}
                            </div>
                            <div onClick={() => navigate("/wishlist")}>
                                <WishlistHeader {...(locationPathName === "/wishlist" ? SelectedSVGStyle : {})} />
                            </div>
                            <div onClick={() => navigate("/profile")}>
                                <ProfileHeader {...(locationPathName === "/profile" ? SelectedSVGStyle : {})} />
                            </div>

                        </div> :
                        <>
                            <div className={classes.div10} style={{ marginRight: "1.7vw"}} onClick={() => navigate("/login")}>Login</div>
                            <div className={classes.div12} onClick={() => navigate("/register")}>Sign Up</div>
                        </>
                    }

                    <button
                        type="button"
                        className={classes.MenuToggle}
                        aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
                        aria-expanded={isMenuOpen}
                        onClick={() => setIsMenuOpen((open) => !open)}
                    >
                        <span className={`${classes.MenuBar} ${isMenuOpen ? classes.MenuBarTop : ''}`} />
                        <span className={`${classes.MenuBar} ${isMenuOpen ? classes.MenuBarHidden : ''}`} />
                        <span className={`${classes.MenuBar} ${isMenuOpen ? classes.MenuBarBottom : ''}`} />
                    </button>
                </div>
            </div>

            {isMenuOpen ? (
                <nav className={classes.MobileNav} aria-label="Primary mobile">
                    {navItems}
                </nav>
            ) : null}
        </>
    );
}
